var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.967,
    height: 20.967
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31845",
    d: "M3.684 20.967h13.6c2.426 0 3.684-1.258 3.684-3.65V3.65c0-2.4-1.258-3.65-3.684-3.65h-13.6C1.258 0 0 1.247 0 3.65v13.667c0 2.404 1.258 3.65 3.684 3.65zm.135-2.2a1.455 1.455 0 01-1.617-1.64v-13.3a1.446 1.446 0 011.617-1.628h13.33a1.451 1.451 0 011.617 1.628v13.3a1.459 1.459 0 01-1.617 1.639zm6.682-14.05a.944.944 0 00-.988.966v5.312l.09 2.3-1.011-1.256-1.269-1.314a.879.879 0 00-.674-.292.883.883 0 00-.91.9.905.905 0 00.258.674l3.718 3.749a1.023 1.023 0 00.786.371 1.085 1.085 0 00.8-.371l3.703-3.751a.914.914 0 00.27-.674.9.9 0 00-.932-.9.875.875 0 00-.674.292l-1.247 1.3-1.037 1.285.1-2.313V5.683a.944.944 0 00-.983-.966z",
    fill: "#fff"
  })));
}

export default SvgDownloadRect;